import { fields, createSchema, validate as _validate } from '..';

import { userRoles } from '../../constants';

const { email, password, name, arrayOfString, organisationOther } = fields;

const trainerSchema = createSchema({
  email,
  name,
  password,
  localAuthorities: arrayOfString,
  organisationOther
});

const participantSchema = createSchema({
  email,
  password,
  name
});

const validate = data => {
  if (data.role === userRoles.trainer || data.role === userRoles.localLead) {
    return _validate(trainerSchema, data);
  } else {
    return _validate(participantSchema, data);
  }
};

export default validate;
